import Echo from 'laravel-echo';
import EventBus from '../event-bus';
import { NOTIFICATIONS_SERVER_URL } from '../constants';

export default {
    start() {
        window.io = require('socket.io-client');

        window.Echo = new Echo({
            broadcaster: 'socket.io',	
            host: NOTIFICATIONS_SERVER_URL,
            auth: {
                headers: {
                    Authorization: null,
                }
            }
        });
    },

    setAuthToken(token) {
		window.Echo.options.auth.headers.Authorization = `Bearer ${token}`;
    },

    startListening(channelId) {
        window.Echo.private(`users.${channelId}`)
            .notification((notification) => {
                notification.formatted_content = this.getNotificationText(notification, notification.type);
                EventBus.$emit('notification', notification);
            });
    },

    getNotificationText(notification, type) {
        if (type.includes('OrderPlaced'))
            return `A new order (#${notification.order_id}) was placed.`;
        else if (type.includes('TableReservationRequestReceived'))
            return `A new table reservation request was received (#${notification.reservation_id}).`;
        else if (type.includes('CommentAdded'))
            return `A new comment was added (#${notification.comment_id}).`;
        else
            return 'You have a new notification.';
    },
};